import Vue from 'vue';
import { config } from '@/scripts/tools/config';
import storage from '@/scripts/tools/storage';

const localStorageMap = {
  layout: true,
  userInfo: true,
  crumbs: true,
  showSideBar: true,
  // uploadNum: true,
  // downloadNum: true
};

const localStore = storage.get('store', 'session') || {};
const saveStore = data => {
  const saveLocalStorage = {};
  Object.keys(data).forEach(key => {
    if (localStorageMap[key]) {
      saveLocalStorage[key] = data[key];
    }
  });
  storage.add('userInfo', saveLocalStorage.userInfo, 'local');
  storage.add('store', saveLocalStorage, 'session');
};

const { location } = window;
const mainDomain = location.host.replace(/^\w+./, '');
const cosbrowserDomain = `cosbrowser.${mainDomain}`;
const officialDomain = mainDomain === 'tencentcloud.com' ? `www.${mainDomain}` : mainDomain;
const consoleDomain = `console.${mainDomain}`;

/**
 * 初始化 store
 */
const state = {
  localeLanguage: storage.get('general.Language') || config.defaultLanguage, // 当前语言环境,
  officialDomain, // 官网主站域名
  consoleDomain, // 控制台域名
  cosbrowserServerUrl: `https://${cosbrowserDomain}`,
  cos5ServerPrefix: `https://cos5.${mainDomain}/cosbrowser/`,
  oauthPrefix: 'https://cos5.cloud.tencent.com/cosbrowser/',

  layout: localStore.layout || 'grid',
  userInfo: {},
  isLogin: false,

  // 面包屑导航
  crumbs: [],
  // 上传文件数
  uploadNum: 0,
  // 下载文件数
  downloadNum: 0,

  showRegion: true,
  showSideBar: localStore.showSideBar || false, // 显示/隐藏侧边栏
  checkedSideBar: -1, // 选中的侧边栏索引
  sideBarSearchKey: '', // 侧边栏搜索字段

  IsQCloudCos: true,
  IsTegCos: false,

  fileLoading: false, // 文件列表 loading 状态
  SyncV4BucketAcl: true,
  SyncV4ObjectAcl: true,
  showUserInfo: true,
};
const store = Vue.observable(state);

/**
 * 初始化 mutations
 */
const mutations = {
  /**
   * 初始化面包屑导航
   */
  initCrumbs() {
    // HACK: 这里单独翻译，因为语言包依赖 store.js
    const name = store.localeLanguage === 'zh' ? '存储桶列表' : 'Bucket List';
    store.crumbs = [{ name, flag: 'root' }];
    saveStore(store);
  },

  getCrumbs() {
    return store.crumbs;
  },

  computeCrumbs(params) {
    const rootName = store.localeLanguage === 'zh' ? '存储桶列表' : 'Bucket List';
    const crumbs = [{ name: rootName, flag: 'root' }];
    if (!params.bucket) {
      saveStore(store);
      return;
    }

    const { bucket, region, path } = params;
    crumbs.push({ name: bucket, region, prefix: '' });

    const prefix = (path || '').replace(/^\//, '');
    let prefixKey = '';

    if (prefix) {
      prefix.split('/').forEach(name => {
        if (name) {
          prefixKey += `${name}/`;
          crumbs.push({ name, prefix: prefixKey });
        }
      });
    }
    store.crumbs = crumbs;
    saveStore(store);
  },

  /**
 * 保存全局信息
 */
  saveStore() {
    saveStore(store);
  },

  /**
   * 更改文件系统布局
   * @param {String} layout
   */
  switchLayout(layout) {
    store.layout = layout;
    saveStore(store);
  },

  /**
   * 登出后清空数据
   */
  initStoreAfterLogout() {
    store.isLogin = false;
    store.crumbs = [];
    // 用户信息
    store.userInfo = {};
    // 上传文件数
    store.uploadNum = 0;
    // 下载文件数
    store.downloadNum = 0;
    saveStore(store);
  },

  /**
   * 修改当前语言环境
   * @param {Sting} lan 语言类型
   */
  changeLocaleLanguage(lan) {
    const { localeLanguage } = state;
    const storagePrefix = 'general.Language';
    if (lan && lan !== localeLanguage) {
      store.localeLanguage = lan;
      storage.add(storagePrefix, lan);
      saveStore(store);
      window.lang.locale = lan;
    }
  },

  // 获取 store 的数据
  synchronousData(obj) {
    Object.assign(store, obj);
  },
};

if (storage.get('store')) {
  const sessionStore = storage.get('store', 'session');
  const obj = (sessionStore !== 'undefined' && sessionStore) || {};
  mutations.synchronousData(obj);
}

export { store, mutations };
